const Tooltip = ({ width, text, isVisible }) => {
  if (!isVisible) return null;
  return (
    <div
      className="position-absolute p-2 bg-white text-dark small shadow tooltip_div"
      style={{
        pointerEvents: isVisible ? "auto" : "none",
        width,
        opacity: isVisible ? 1 : 0,
      }}>
      <div className="tooltip_sub_div"/>
      {text}
    </div>
  );
};

export default Tooltip;
